import styled, {css} from 'styled-components'

export const StyledAgendaPageWrapper = styled.div(
    ({theme: {palette}}) => css`
        display: grid;
        grid-template-columns: 240px 1fr;
        height: 100%;
        background-color: ${palette.neutral['50']};
    `
)
